import React from 'react';
import TrailMapCard from './TrailMapCard';
import ElevationProfileCard from './ElevationProfileCard';

/**
 * Service Info Card Registry
 * Maps card types to their components
 *
 * To add new card types:
 * 1. Create a new component in this directory
 * 2. Import it above
 * 3. Add it to the CARD_TYPES registry below
 */
const CARD_TYPES = {
  trailMap: TrailMapCard,
  elevationProfile: ElevationProfileCard,
  // Add more card types here as needed:
  // waterConditions: WaterConditionsCard,
  // skiReport: SkiReportCard,
  // weatherForecast: WeatherForecastCard,
  // etc.
};

/**
 * ServiceInfoRenderer Component
 * Dynamically renders service-specific information cards
 * based on configuration from the API
 *
 * @param {Array} cards - Array of card configurations from API
 * Example API response:
 * {
 *   serviceInfoCards: [
 *     {
 *       type: 'trailMap',
 *       data: { mapImage: '...', trailPoints: [...] }
 *     },
 *     {
 *       type: 'elevationProfile',
 *       data: { elevationPoints: [...], keyLocations: [...] }
 *     }
 *   ]
 * }
 */
export default function ServiceInfoRenderer({ cards = [] }) {
  if (!cards || cards.length === 0) {
    return null;
  }

  return (
    <div>
      {cards.map((card, index) => {
        const CardComponent = CARD_TYPES[card.type];

        if (!CardComponent) {
          console.warn(`Unknown service info card type: ${card.type}`);
          return null;
        }

        return (
          <CardComponent
            key={`${card.type}-${index}`}
            {...card.data}
          />
        );
      })}
    </div>
  );
}
